import { useDispatch, useSelector } from "react-redux";
import { inProgress, isNullOrUndefined } from "src/common/utils";
import { isNullCondition } from "src/components/condition/utils/isNullCondition";
import KeyConditionInputs from "src/components/KeyConditionInputs";
import { MemberInfoListActions } from "src/pages/userGroups/PreviewKeyCondition/model";
import { RootState } from "src/redux/store";
import AsyncUsersTable from "../../common/asyncUsersTable";
import { useGetIndividualInclusions } from "../../common/hooks/GetIndividualInclusions";
import { KeyConditionAction } from "../../model";
import MemberAction from "../../SelectKeyCondition/member-actions";
import "./index.scss";
import SearchByUsers from "./selectMember";

function ByCondition({ userGroupUniqueName, setCurrentStepState, setDisplayLabels }) {
  const dispatch = useDispatch();
  const action = useSelector((rootState: RootState) => rootState.keyCondition.action);
  const { modifiedKeyCondition: editedCondition } = useSelector((rootState: RootState) => {
    return rootState.keyCondition;
  });
  const SelectKeyConditionTableHeading = "People who match the key condition";
  const {
    value: { data, totalElements },
    progress,
    error,
  } = useSelector(
    (rootState: RootState) => rootState.membersMatchingConditionList.membersMatchingConditionList
  );
  const columns = useSelector(
    (rootState: RootState) => rootState.membersMatchingConditionList.columns
  );
  const individualInclusionsList = useGetIndividualInclusions(userGroupUniqueName);
  const excludedMembers: Array<{ userId: string }> = useSelector(
    (rootState: RootState) => rootState.membersMatchingConditionList.excludedMembers
  );
  const selectedUser = useSelector((rootState: RootState) => rootState.keyCondition.selectedUser);
  const isUserExcluded = (user) =>
    Boolean(excludedMembers.find((excludedMember) => excludedMember.userId === user.key));

  const rowClassNameFn = (user) => (isUserExcluded(user) ? "member-excluded" : "");
  function usersMatchingGivenCondition(page, size) {
    if (!isNullCondition(editedCondition)) {
      dispatch(
        // @ts-ignore
        MemberInfoListActions.getMemberInfoList({
          page: page,
          size: size,
          condition: editedCondition,
        })
      );
    }
  }

  return (
    <div className="manage-members-by-condition-container">
      {action === KeyConditionAction.ADD ? (
        <>
          <div className="label">Select the member name's to view their conditions.</div>
          <SearchByUsers
            setCurrentStepState={setCurrentStepState}
            setDisplayLabels={setDisplayLabels}
          />
        </>
      ) : null}
      {action === KeyConditionAction.ADD ? (
        <>
          {isNullOrUndefined(selectedUser) ? (
            <div className="label">
              Select conditions to view the list of members who match them.
            </div>
          ) : null}
        </>
      ) : (
        <div className="label">
          Edit the existing condition and view the list of members who match them.
        </div>
      )}
      <KeyConditionInputs isIndividualInclusionMember={false} />
      {!isNullCondition(editedCondition) ? (
        <>
          <div className="key-condition-table-heading">
            {SelectKeyConditionTableHeading}{" "}
            <span className="key-condition-table-heading-bold">({totalElements})</span>
          </div>
          <AsyncUsersTable
            error={error}
            dataSource={data}
            columns={[
              ...columns,
              {
                title: "Actions",
                render: (user) => <MemberAction user={user} userGroupName={userGroupUniqueName} />,
              },
            ]}
            tableId={"UsersMatchingConditions"}
            loading={inProgress(progress)}
            totalElements={totalElements}
            individualInclusions={individualInclusionsList}
            dispatchCallBack={usersMatchingGivenCondition}
            mainApiRequestData={editedCondition}
            rowClassName={rowClassNameFn}
          />
        </>
      ) : null}
    </div>
  );
}

export default ByCondition;
